export const ADD_SESSION = 'ADD_SESSION';
export const CHANGE_SESSION = 'CHANGE_SESSION';
export const DELETE_SESSION = 'DELETE_SESSION';
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const UPDATE_WORKLOAD = 'UPDATE_WORKLOAD';
export const SAVE_DATA = 'SAVE_DATA';
export const SERVER_ERROR = 'SERVER_ERROR';
export const COUNTRY_CHANGE = 'COUNTRY_CHANGE'
export const TOGGLE_SIZE_BUTTON = 'TOGGLE_SIZE_BUTTON';
export const CLOSE_EULA = 'CLOSE_EULA';
export const ERROR_SESSION = 'ERROR_SESSION';
export const CLEAR_GUIDANCE_ERROR= 'CLEAR_GUIDANCE_ERROR';
export const POSTSSET_PENDING='POSTSSET_PENDING';

export const CHECK_LOGIN = 'CHECK_LOGIN';


export const asyncActionType = (type) => ({
  PENDING: `${type}_PENDING`,
  SUCCESS: `${type}_SUCCESS`,
  ERROR: `${type}_ERROR`,
});

// API
export const API_REQUEST = 'API_REQUEST';
export const API_REQUEST_POST = 'API_REQUEST_POST';
export const API_REQUEST_BLOB = 'API_REQUEST_BLOB';
export const API_REQUEST_POST_BLOB = 'API_REQUEST_POST_BLOB';
export const CANCEL_API_REQUEST = 'CANCEL_API_REQUEST';
export const REDIRECT_CONFLICT = 'REDIRECT_CONFLICT';

export const EPA_ACTV_SOLN_CHANGE = 'EPA_ACTV_SOLN_CHANGE';
export const OPENED_SAVEWORKLOAD = 'OPENED_SAVEWORKLOAD';

// Recipes
export const FETCH_WORKLOADS = asyncActionType('FETCH_WORKLOADS');
export const FETCH_BOM = asyncActionType('FETCH_BOM');
export const FETCH_GR_INPUT = asyncActionType('FETCH_GR_INPUT');
export const FETCH_GRBOM = asyncActionType('FETCH_GRBOM');
export const FETCH_CONFIGDETAILS = asyncActionType('FETCH_CONFIGDETAILS');
export const FETCH_DEFAULT_DATA = asyncActionType('FETCH_DEFAULT_DATA');
export const FETCH_SOLUTION = asyncActionType('FETCH_SOLUTION');
export const FETCH_SOLUTION_ADVANCED = asyncActionType('FETCH_SOLUTION_ADVANCED');
export const SAVE_WORKLOAD = asyncActionType('SAVE_WORKLOAD');
export const SAVE_SOLUTION = asyncActionType('SAVE_SOLUTION');
export const LOAD_USER_DATA = asyncActionType('LOAD_USER_DATA');
export const LOAD_SELECTION = asyncActionType('LOAD_SELECTION');
export const DELETE_SELECTION = asyncActionType('DELETE_SELECTION');
export const SAP_SOL_PREVIEW = asyncActionType('SAP_SOL_PREVIEW');
export const SAPHANA_SOL_PREVIEW = asyncActionType('SAPHANA_SOL_PREVIEW'); 
export const SAPTDI_SOL_PREVIEW = asyncActionType('SAPTDI_SOL_PREVIEW');


export const FETCH_METRICS_DATA = asyncActionType('FETCH_METRICS_DATA');
export const FETCH_COMPARE_METRICS_DATA = asyncActionType('FETCH_COMPARE_METRICS_DATA');
export const FETCH_COMPARE_SOLUTION = asyncActionType('FETCH_COMPARE_SOLUTION');

export const VALIDATE_WORKLOAD = asyncActionType('VALIDATE_WORKLOAD');
export const FETCH_RA_BOM = asyncActionType('FETCH_RA_BOM');
export const EPA_FETCH_SUPPORTEDLIST = asyncActionType('EPA_FETCH_SUPPORTEDLIST');
export const EPA_DOWNLOAD_METRICS = asyncActionType('EPA_DOWNLOAD_METRICS');
export const EPA_EXPORT_COMPARESOLUTIONDATA = asyncActionType('EPA_EXPORT_COMPARESOLUTIONDATA');
export const UPDATE_LOOKUPSERVERS=asyncActionType('UPDATE_LOOKUPSERVERS');

export const POST_USER_DATA = asyncActionType('POST_USER_DATA');
export const UNSUBSCRIBE_USER_DATA = asyncActionType('UNSUBSCRIBE_USER_DATA');

export const FETCH_USER_BUSINESS_INFO = asyncActionType('FETCH_USER_BUSINESS_INFO');
export const COMPARE_SOL_DATA = asyncActionType('COMPARE_SOL_DATA');
export const LOGOUT = asyncActionType('LOGOUT');
export const COMPARE_GLGROWTH_DATA = asyncActionType('COMPARE_GLGROWTH_DATA');
export const LOGIN = asyncActionType('LOGIN');
export const SSOLOGIN = asyncActionType('SSOLOGIN');
export const SHARE_SELECTION = asyncActionType('SHARE_SELECTION');
export const ACCEPT_WLSL = asyncActionType('ACCEPT_WLSL');
export const REJECT_WLSL = asyncActionType('REJECT_WLSL');
export const LOAD_NOTIFICATIONS = asyncActionType('LOAD_NOTIFICATIONS');
export const DOWNLOAD_FILE = asyncActionType('DOWNLOAD_FILE');
export const FETCH_SETTINGS = asyncActionType('FETCH_SETTINGS');
export const GET_WORKLOAD_WITH_MAINSTREAM  = asyncActionType('GET_WORKLOAD_WITH_MAINSTREAM');



// WEBPACK FOOTER //
// ./src/State/constants/actionTypes.js